import { useState } from "react";

import { isEmpty, keyBy } from "lodash";
import debounce from "lodash/debounce";
import useSWR from "swr";

import Select, { SelectOption } from "components/uikit/select";

import { useApplicationContext } from "contexts/app";

import { DEFAULT_PAGE_SIZE } from "utils/http-client-utils";

const SelectFuelStationChain = ({ chain, onSearch, loading, ...props }: any) => {
  const [search, setSearch] = useState(false);
  const { session } = useApplicationContext();

  const defaultQuery = `?account${session?.accountId}&page_size=${DEFAULT_PAGE_SIZE}`;
  const searchQuery = defaultQuery + `&search=${search}`;
  const url = search ? `fuel_station_chains/${searchQuery}` : `fuel_station_chains/${defaultQuery}`;

  const { data } = useSWR(url);

  const keyedData = keyBy(data, "url");
  const exist = keyedData[chain];
  const { data: chainData } = useSWR(!exist && chain);

  if (isEmpty(search) && data && chainData) {
    data.unshift(chainData);
  }

  const onSearchDefault = debounce((value) => setSearch(value), 500);

  return (
    <Select {...props} showSearch onSearch={onSearch || onSearchDefault} loading={loading} filterOption={false}>
      {data?.map(({ name, url }: { name: string; url: string }) => (
        <SelectOption key={url} value={url}>
          {name}
        </SelectOption>
      ))}
    </Select>
  );
};

export default SelectFuelStationChain;
